import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';

import './style.css';
import { auth } from '../../../firebase-init';
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

export default function Sidebar({ openSidebar, setOpenSidebar, user }) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  let location = useLocation();
  let history = useHistory();
  const cookies = new Cookies();
  const logout = () => {
    auth.signOut();
  };

  const goToHome = (id, name) => {
    history.push('/home');
  };

  const goToTheses = () => {
    history.push('/theses');
  };

  const goToPNST = () => {
    window.open('https://www.pnst.cerist.dz/recherche.php', '_blank');
  };

  const goToINAPI = () => {
    history.push('/publications/conference-proceedings');
  };

  const goToArabicCouncil = () => {
    history.push('/publications/council-books');
  };

  const goToCNERH = () => {
    history.push('/publications/cnerh');
  };

  const goToBookPurchase = () => {
    history.push('/visitor/books');
  };

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpenSidebar(open);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    cookies.set('language', lang);
  };

  const list = () => (
    <div
      className={clsx(classes.list) + ' sidebar-container'}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div className="logo-container-sidebar">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <img className="logo" src="/assets/images/IQRAA.png" alt="UDL" onClick={goToHome} />
          <div className="language-switcher">
            <div className={i18n.language === 'ar' ? 'language-item active' : 'language-item'} style={{cursor:'pointer'}} onClick={() => changeLanguage('ar')}>
              AR
            </div>
            &nbsp;&nbsp;
            <div className={i18n.language === 'fr' ? 'language-item active' : 'language-item'} style={{cursor:'pointer'}} onClick={() => changeLanguage('fr')}>
              FR
            </div>
            &nbsp;&nbsp;
            <div className={i18n.language === 'en' ? 'language-item active' : 'language-item'} style={{cursor:'pointer'}} onClick={() => changeLanguage('en')}>
              EN
            </div>
          </div>
        </div>
      </div>
      <div className="container container-links">
        <div className="menu-mobile-container">
          <Link to="/" className={location.pathname === '/' ? 'menu-item active' : 'menu-item'}>
            {t('header.home')}
          </Link>
        </div>
        <div className="menu-mobile-container">
          <Link to="/books" className={location.pathname.includes('/books') ? 'menu-item active' : 'menu-item'}>
            {t('header.books')}
          </Link>
        </div>
        <div className="menu-mobile-container">
          <span 
            className="menu-item"
            onClick={goToPNST}
            style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
            title={t('publicationsDropdown.researchPapers')}
          >
            {t('header.pnstShort')}
          </span>
        </div>
        <div className="menu-mobile-container">
          <span 
            className="menu-item"
            onClick={goToINAPI}
            style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
            title={t('publicationsDropdown.conferenceProceedings')}
          >
            {t('header.inapiShort')}
          </span>
        </div>
        <div className="menu-mobile-container">
          <span 
            className="menu-item"
            onClick={goToArabicCouncil}
            style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
            title={t('publicationsDropdown.councilBooks')}
          >
            {t('header.conseilArabeShort')}
          </span>
        </div>
        <div className="menu-mobile-container">
          <span 
            className="menu-item"
            onClick={goToCNERH}
            style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
            title={t('header.cnerh')}
          >
            {t('header.cnerhShort')}
          </span>
        </div>
        <div className="menu-mobile-container">
          <Link
            to="/publications/el-madjlis-hci"
            className={location.pathname === '/publications/el-madjlis-hci' ? 'menu-item active' : 'menu-item'}
            title={t('header.elMadjlisHci')}
            onClick={() => setOpenSidebar(false)}
          >
            {t('header.elMadjlisHci')}
          </Link>
        </div>
        <div className="menu-mobile-container">
          <span 
            className="menu-item"
            onClick={goToBookPurchase}
            style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
          >
            {t('header.bookPurchase')}
          </span>
        </div>
        <div className="menu-mobile-container">
          <div className="dropdown">
            <span 
              className="dropdown-toggle menu-item" 
              role="button" 
              id="publicationsDropdownMobile" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
              style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
            >
              {t('header.publications')}
            </span>
            <ul className="dropdown-menu" aria-labelledby="publicationsDropdownMobile">
              <li>
                <Link 
                  to="/publications/books" 
                  className="dropdown-item"
                >
                  {t('publicationsDropdown.books')}
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.echaab.dz/journal-archive/" 
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('publicationsDropdown.reports')}
                </a>
              </li>
              <li>
                <a 
                  href="https://www.horizons.dz/category/archives-pdf/" 
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('publicationsDropdown.horizonsJournal')}
                </a>
              </li>
              <li>
                <a 
                  href="https://aala.dz/%d8%a7%d9%84%d9%85%d9%86%d8%b4%d9%88%d8%b1%d8%a7%d8%aa/%d9%85%d9%86%d8%b4%d9%88%d8%b1%d8%a7%d8%aa-%d8%a3%d8%ae%d8%b1%d9%89/" 
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('publicationsDropdown.aalaPublications')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="menu-mobile-container">
          <Link to="/contact" className={location.pathname === '/contact' ? 'menu-item active' : 'menu-item'}>
            {t('header.contact')}
          </Link>
        </div>
        <div className="menu-mobile-container">
          <Link to="/app" className={location.pathname === '/app' ? 'menu-item active' : 'menu-item'}>
            {t('header.app')}
          </Link>
        </div>
        
        {user !== null ? (
          <>
          <div className="menu-mobile-container">
          <Link to="/profile" className={location.pathname === '/profile' ? 'menu-item active' : 'menu-item'}>
            {t('header.profile')}
          </Link>
        </div>

        <div className="menu-mobile-container" onClick={logout}>
          <div className={'menu-item'}>{t('header.logout')}</div>
        </div></>
        ) 
        : (
          <>
            {/* <div className="menu-mobile-container">
              <Link to="/registration" className={location.pathname === '/registration' ? 'menu-item active' : 'menu-item'}>
                {t('login.form.register')}
              </Link>
            </div> */}
            <div className="menu-mobile-container">
              <Link to="/login" className={location.pathname === '/login' ? 'menu-item active' : 'menu-item'}>
                {t('login.form.connect')}
              </Link>
            </div>
      </>
        )}
        
      </div>
    </div>
  );

  return (
    <SwipeableDrawer
      anchor={i18n.language === 'ar' ? 'right' : 'left'}
      open={openSidebar}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
    >
      {list()}
    </SwipeableDrawer>
  );
}
